export default "__VITE_ASSET__CNi5_eXr__"